<template>
  <div>
    <div class="col-md-12">
      <img src="@/assets/images/logo/enviame.svg" alt="login" class="mx-auto mt-2" width="200">
    </div>
    <hr>
    <div class="container">
      <div class="main-section">
        <!-- Sección izquierda: Información del pedido -->
        <div class="info-section border-right">
          <div class="icon-container">
            <img :src="panel.svg" alt="Icono Camión" class="truck-icon">
          </div>

          <div v-if="show.info">
            <ul class="details-list">
              <!-- Seller -->
              <li class="mb-1">
                <span>
                  <feather-icon icon="UserIcon" size="1x"/>
                </span> 
                <span class="ml-1">
                  <strong>Comercio:</strong> {{ pickup.company.name || '--' }}
                </span>
              </li>
              <!-- Bultos y peso -->
              <li class="mb-1">
                <span>
                  <feather-icon icon="HashIcon" size="1x"/>
                </span> 
                <span class="ml-1">
                  <strong>Bultos:</strong> {{ pickup.qty || '--' }} bultos - {{ pickup.weight || '--' }} Kg
                </span>
              </li>
              <!-- Dimensiones -->
              <li class="mb-1">
                <span>
                  <feather-icon icon="PackageIcon" size="1x"/>
                </span> 
                <span class="ml-1">
                  <strong>Dimensiones:</strong> {{ pickup.dimensions || '--' }} ({{ pickup.dimetion_label || '--' }})
                </span>
              </li>
              <!-- Dias y Fecha -->
              <div>
                <p class="d-flex align-items-start">
                  <feather-icon icon="CalendarIcon" size="1x" class="mt-1"/>
                  <span class="ml-1 d-flex flex-column">
                    <span>
                      <strong>Días:</strong> {{ pickup.format_pickup_days || '--' }}
                    </span>
                    <span>
                      <strong>Fecha inicio:</strong> {{ pickup.start_date || '--' }}
                    </span>
                  </span>
                </p>
              </div>
              <!-- Rango horario -->
              <li class="mb-1">
                <span>
                  <feather-icon icon="ClockIcon" size="1x"/>
                </span> 
                <span class="ml-1">
                  <strong>Horario:</strong> {{ pickup.range_time || '--' }}
                </span>
              </li>
              <!-- Carrier -->
              <li class="mb-1">
                <span>
                  <feather-icon icon="TruckIcon" size="1x"/>
                </span> 
                <span class="ml-1">
                  <strong>Courier:</strong> {{ pickup.carrier.name || '--' }}
                </span>
              </li>
            </ul>
            <div class="warehouse-info mt-3">
              <p>Info. Bodega</p>
              <p class="d-flex align-items-start">
                <feather-icon icon="MapPinIcon" size="1x" class="mt-1"></feather-icon>
                <span class="ml-1 d-flex flex-column">
                  <span>
                    <strong>Direccion</strong> {{ pickup.address.full_address || '--' }}
                  </span>
                  <span>
                    <strong>Comuna:</strong> {{ pickup.address.place || '--' }}
                  </span>
                </span>
              </p>
              <p class="d-flex align-items-start">
                <feather-icon icon="PhoneIcon" size="1x" class="mt-1"></feather-icon>
                <span class="ml-1 d-flex flex-column">
                  <span>
                    <strong>Contacto:</strong> {{ pickup.warehouse.contact.name || '--' }}
                  </span>
                  <span>
                    <strong>Teléfono:</strong> {{ pickup.warehouse.contact.phone || '--' }}
                  </span>
                </span>
              </p>
            </div>
            <div class="obs-info mt-3" v-if="pickup.address.information">
              <p>Observaciones</p>
              <p>
                <feather-icon icon="AlertCircleIcon" size="1x"/>
                <span class="ml-1">
                  {{ pickup.address.information || '--' }}
                </span>
              </p>
            </div>
          </div>
        </div>
        
        <!-- Sección derecha: Confirmación solicitud -->
        <div v-if="showForm" class="confirmation-section ml-3 mt-4">
          <div class="text-center">
            <p class="title-confirm">Confirmación solicitud programa frecuentes</p>
            <p class="text-confirm"> {{ summaryText }} </p>
          </div>
          
          <b-form-group class="my-2">
            <b-form-radio-group v-model="form.request_status" name="options" class="d-flex justify-content-start">
              <b-form-radio value="approved">Aceptar solicitud</b-form-radio>
              <b-form-radio value="rejected">Rechazar solicitud</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          
          <b-form @submit.prevent="onSubmit">
            <b-form-group :label="reasonLabel" class="mb-1">
              <b-form-textarea
                v-model="form.reason"
                placeholder="Ingrese descripción corta del motivo"
                required
              ></b-form-textarea>
            </b-form-group>

            <b-form-group label="Número propio de reserva">
              <b-form-input
                v-model="form.carrier_pickup_number"
                placeholder="Ingrese el número de reserva"
                required
              ></b-form-input>
            </b-form-group>
            
            <div class="d-flex justify-content-center mt-2">
              <!-- <b-button type="submit" variant="outline-success" :disabled="disabled.submitButton">Enviar</b-button> -->
              <b-button type="submit" :disabled="disabled.submitButton" variant="outline-success">
                Enviar
                <i v-if="loading.confirmButton" :class="['fa', 'fa-spinner', 'fa-spin']"/> 
              </b-button>
            </div>
          </b-form>

          <p class="info-text mt-3">Una vez acepte o rechace se le informará al cliente la resolución de la solicitud.</p>
        </div>

        <div v-if="!showForm" class="col-md-12 margin-message text-center">
          <h4 class="message-font"> {{ panel.message }} </h4>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import PublicPickupsService from './public-pickups.service'
export default {
  data () {
    return {
      form: {
        request_status: 'approved'
      },
      pickup: null,
      truckImgs: {
        truck: require('@/assets/images/images-on-components/pickups/truck.svg'),
        truckError: require('@/assets/images/images-on-components/pickups/truckError.svg'),
        truckSuccess: require('@/assets/images/images-on-components/pickups/truckSuccess.svg')
      },
      reasonLabel: 'Motivo aceptación',
      disabled: {
        submitButton: false
      },
      loading: {
        confirmButton: false
      },
      panel: {
        message: '',
        svg: ''
      },
      showForm: false,
      show: {
        info: false
      },
      summaryText: '',
      dayTranslations : {
        mon: { abbrev: 'Lun', full_text: 'Lunes' },
        tue: { abbrev: 'Mar', full_text: 'Martes' },
        wed: { abbrev: 'Mié', full_text: 'Miércoles' },
        thu: { abbrev: 'Jue', full_text: 'Jueves' },
        fri: { abbrev: 'Vie', full_text: 'Viernes' },
        sat: { abbrev: 'Sáb', full_text: 'Sábado' },
        sun: { abbrev: 'Dom', full_text: 'Domingo' }
      },
      sizePickup: {
        xs: { id: 'xs', text: 'Sobre', content: '20cm x 20cm x 1cm' },
        s: { id: 's', text: 'Pequeño', content: '10cm x 15cm x 5cm' },
        m: { id: 'm', text: 'Mediano', content: '20cm x 30cm x 10cm' },
        l: { id: 'l', text: 'Grande', content: '40cm x 60cm x 30cm' },
        c: { id: 'c', text: 'Más Grande', content: 'Otras medidas' }
      },
      PublicPickupsService: new PublicPickupsService(this)
    }
  },
  mounted () {
    this.initializeData()
  },
  watch: {
    'form.request_status' () {
      if (!this.form.request_status) this.disabled.submitButton = true
      else this.disabled.submitButton = false
      this.changeStatus()
    }
  },
  methods: {
    initializeData () {
      document.getElementById('loading-bg').style.display = 'block'
      this.panel.svg = this.truckImgs.truck
      this.PublicPickupsService.callService('getConfirmFrequentPickupData', null, { uuid: this.$route.params.uuid }, { fullResponseError: true })
        .then(resp => {
          if (resp.data.status === 'available') {
            this.show.info = true
            this.showForm = true
            this.pickup = this.formatResponse(resp.data)
          }
          if (resp.data.status === 'expired') {
            this.showForm = false
            this.show.info = false
            this.panel.svg = this.truckImgs.truckError
            this.panel.message = 'Lo sentimos, ya no es posible responder la solicitud.'
          }
          if (resp.data.status === 'answered') {
            this.showForm = false
            this.show.info = true
            this.panel.svg = this.truckImgs.truckSuccess
            this.panel.message = resp.data.message
            this.pickup = this.formatResponse(resp.data)
          }
        })
        .catch(error => {
          console.error(error)
          this.$alert(`Ha ocurrido un error: ${error.data}`)
        })
        .finally(() => {
          // Desactiva el spinner de la plataforma
          document.getElementById('loading-bg').style.display = 'none'
        })
    },
    formatResponse(data) {
      data.format_pickup_days = data.pickup_days
        .map(day => this.dayTranslations[day.toLowerCase()]?.abbrev || 'Día inválido')
        .join(', ')

      data.format_pickup_days_full_text = data.pickup_days
        .map(day => this.dayTranslations[day.toLowerCase()]?.full_text || 'Día inválido')
        .join(', ')

      data.dimetion_label = this.sizePickup[data.size].text || 'Mediano'
      return data
    },
    buildSummaryText(data) {
      const { company } = data
      return `${company.name} ha solicitado el inicio del programa semanal, los días Lunes, Martes y Viernes entre las 10 y las 12 A.M.`
    },
    changeStatus () {
      if (this.form.request_status === 'approved') this.reasonLabel = 'Motivo aceptación'
      else this.reasonLabel = 'Motivo rechazo'
      this.form.reason = ''
    },
    onSubmit (event) {
      event.preventDefault()
      this.loading.confirmButton = true
      this.disabled.submitButton = true
      const queryParams = {
        request_status: this.form.request_status,
        reason: this.form.reason,
        carrier_pickup_number: this.form.carrier_pickup_number
      }

      this.PublicPickupsService.callService('confirmFrequentPickup', queryParams, { uuid: this.$route.params.uuid })
        .then(resp => {
          this.showForm = false
          this.show.info = true
          this.panel.svg = this.truckImgs.truckSuccess
          this.panel.message = resp.data.message
        })
        .catch(error => {
          console.error(error)
          this.$alert('Ha ocurrido un error inesperado.')
        })
        .finally(() => {
          this.loading.confirmButton = false
          this.disabled.submitButton = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-message {
  margin-top: 15%;
}

.main-section {
  display: grid;
  grid-template-columns: 40% 60%;
  align-items: center; /* Centra verticalmente los elementos */
}


.border-right {
  border-right: 1px solid;
}

.info-section {
  padding: 20px;
  width: 90%;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100px;
  min-height: 100px; 
  width: 150px; 
  height: 150px;
}

.truck-icon {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none; 
}

.title-confirm {
  color: #0D47A1;
  font-size: 20px;
  font-weight: bold;
}

.text-confirm {
  font-size: 18px;
}

.details-list {
  list-style: none;
  padding: 0;
  font-size: 18px;
}

.details-list li {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.warehouse-info {
  margin-top: 20px;
  font-size: 17px;
}
.obs-info {
  margin-top: 20px;
  font-size: 17px;
}

.confirmation-section {
  padding: 20px;
  width: 50%;
  padding: 20px;
}

.info-text {
  font-size: 12px;
  color: #888;
  text-align: center;
  margin-top: 10px;
}

.submit-button {
  margin: 0 auto;
}

</style>